module.exports = __webpack_public_path__ + "static/media/gps-rojo.4e84e5b5.svg";